import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Modal } from '@/components/ui/Modal';
import { formatInstituteDate } from '@/features/teacher/utils';
import type { StudentHomework } from '@/types/student';

interface HomeworkRepoModalProps {
  repoFor: StudentHomework | null;
  repoUrl: string;
  onRepoUrlChange: (url: string) => void;
  onClose: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export function HomeworkRepoModal({
  repoFor,
  repoUrl,
  onRepoUrlChange,
  onClose,
  onSubmit,
  isSubmitting,
}: HomeworkRepoModalProps) {
  return (
    <Modal
      isOpen={Boolean(repoFor)}
      onClose={onClose}
      title="Hand in your repository"
      description={repoFor ? `${repoFor.title} · ${repoFor.subject.name}` : undefined}
      footer={
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            isLoading={isSubmitting}
            disabled={repoUrl.trim().length === 0}
            onClick={onSubmit}
          >
            Hand in
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <Input
          label="Repository link"
          type="url"
          inputMode="url"
          autoComplete="off"
          placeholder="https://github.com/your-name/your-project"
          hint="Make sure your teacher can open it — a private repository they cannot see counts as nothing handed in."
          value={repoUrl}
          onChange={(event) => onRepoUrlChange(event.target.value)}
        />
        {repoFor?.submission?.repoUrl && (
          <p className="text-xs text-ink-3">
            You handed in {repoFor.submission.repoUrl} on{' '}
            {formatInstituteDate(repoFor.submission.handedInOn)}. Handing in again replaces it.
          </p>
        )}
      </div>
    </Modal>
  );
}
